import { Link } from "react-router-dom";
import { CONTACT } from "@/data/content";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="bg-charcoal text-ivory relative overflow-hidden grain grain-dark" data-testid="site-footer">
      <div className="container-editorial py-20 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <Logo variant="light" />
            <p className="font-display text-3xl md:text-4xl mt-8 max-w-md leading-tight text-ivory">
              Strategic Workforce, Talent & HR Transformation Services.
            </p>
            <p className="text-sm text-[#9CA3AF] mt-6 max-w-md leading-relaxed">
              A consulting-led HR and workforce solutions practice — solving complex talent, workforce, and
              organizational challenges for enterprises, GCCs, startups, and growth-stage organizations.
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <div className="eyebrow eyebrow-slate text-gold">Contact</div>
            <ul className="mt-6 space-y-3 text-sm text-[#D8D5CE]">
              <li>{CONTACT.founder} · Founder</li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="editorial-link break-all" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="editorial-link" data-testid="footer-phone">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="text-[#9CA3AF]">{CONTACT.website}</li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="eyebrow eyebrow-slate text-gold">Navigate</div>
            <div className="mt-6 flex flex-col gap-2 text-sm text-[#D8D5CE]">
              <Link to="/about" className="editorial-link inline-block w-max">About</Link>
              <Link to="/services" className="editorial-link inline-block w-max">Services</Link>
              <Link to="/career-advisory" className="editorial-link inline-block w-max">Career Advisory</Link>
              <Link to="/contact" className="editorial-link inline-block w-max">Contact</Link>
              <Link to="/admin/login" className="editorial-link inline-block w-max text-[#7d7a72]" data-testid="footer-admin-link">Admin</Link>
            </div>
          </div>
        </div>

        <div className="hairline-dark mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#7d7a72]">
            © {new Date().getFullYear()} EdRoy Consigliere · All rights reserved.
          </div>
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#7d7a72]">
            Practice · advisory + execution
          </div>
        </div>
      </div>
    </footer>
  );
}
